<template>
  <b-row align-v="center" class="px-2 py-0">
    <!-- <b-col md="auto" class="pl-0">
      <img
        alt="user"
        class="w-6 avatar rounded-full"
        :src="userImage"
        v-if="userImage"
      />

      <b-avatar variant="primary" class="p-3 avatar" v-else></b-avatar>
    </b-col> -->
    <!-- <b-avatar variant="primary" class="p-1 avatar"></b-avatar> -->
    <b-avatar variant="primary" class="p-3 grycyanavtr"></b-avatar>
    <b-col class="pl-0 pr-0 ml-1">
      <div class="d-flex justify-content-between align-items-center">
        <div class="ml-2">
          <h4 class="mb-0 text-sm font-semibold">{{ name }}</h4>
        </div>

        <div class="flex">
          <feather-icon
            icon="CheckIcon"
            class="p-2 rounded-full text-success cust-border-ch mr-2"
            @click.stop="handleClick('accept')"
          />
          <feather-icon
            icon="XIcon"
            class="p-2 rounded-full text-danger cust-border-ch"
            @click.stop="handleClick('reject')"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    request: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    name() {
      return `${this.request._user.firstname} ${this.request._user.lastname}`;
    },
    userImage() {
      return (
        this.request._user.userImage &&
        `${this.$imageURL}/${this.request._user.userImage}`
      );
    },
    ...mapState("channel", {
      selectedChannel: "selectedChannel",
    }),
  },
  methods: {
    async handleClick(action) {
      const payload = {
        channelID: this.selectedChannel._id,
        userID: this.request._user.id,
      };
      let loader = this.$loading();
      try {
        if (action === "accept") {
          await this.acceptRequest(payload);
        } else if (action === "reject") {
          await this.rejectRequest(payload);
        }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    acceptRequest(payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$store.dispatch(
            "channel/acceptJoin",
            payload
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    rejectRequest(payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await this.$store.dispatch(
            "channel/rejectJoin",
            payload
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
</script>
